import * as richTextRenderer from '@contentful/rich-text-plain-text-renderer';

export const isPlainObject = (value) =>
  Array.isArray(value) && value.length
    ? false
    : value !== null && typeof value === 'object' && !Array.isArray(value);

export const getContentAsText = (
  input,
  initialValues = [],
  key = 'unknown'
) => {
  const WHITELIST = [
    'content',
    'headline',
    'subline',
    'label',
    'raw',
    'body',
    'slug',
    'articleCategories',
    'text',
    'keywords',
  ];
  const richTextFields = ['raw'];
  if (isPlainObject(input))
    return [
      ...initialValues,
      ...Object.keys(input)
        .filter(
          (key) =>
            WHITELIST.includes(key) ||
            Object.keys(input).some((key) => WHITELIST.includes(key))
        )
        .map((key) => {
          if (richTextFields.includes(key)) {
            return getContentAsText(
              richTextRenderer.documentToPlainTextString(
                JSON.parse(input[key])
              ),
              initialValues,
              key
            );
          }
          return getContentAsText(input[key], initialValues, key);
        }),
    ].flat();

  if (Array.isArray(input))
    return [
      ...initialValues,
      ...input.map((val) => getContentAsText(val, initialValues)),
    ].flat();

  if (WHITELIST.includes(key)) {
    return [...initialValues, input];
  }

  return initialValues;
};
